import React, { useEffect } from 'react'
import styles1 from './HelpOnTwitter.module.css'
import ArticleCoverAndHeader from '../ArticleComponents/ArticleCoverAndHeader'
import styles from '../ArticleComponents/Common.module.css'
import Row from '../ArticleComponents/Row';

function HelpOnTwitter() {
  
    useEffect(() => {
        window.scroll({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
      })

      const wearMask = {
        listItem:["Clean your hands before you put your mask on, as well as before and after you take it off, and after you touch it at any time." ,"Make sure it covers both your nose, mouth and chin."  ,"When you take off a mask, store it in a clean plastic bag, and every day either wash it if it’s a fabric mask, or dispose of a medical mask in a trash bin." ,"Don’t use masks with valves."]
      }

      const refList ={
        heading: "Important videos on masks",
        linkList: [
          {linkTitle:"Make hand sanitizer part of your mask wearing routine",link:"https://www.youtube.com/watch?v=GEIYCvcOHLw&t=5s"},
        {linkTitle:"When to wear a mask",link:"https://www.youtube.com/watch?v=vohiTyczR8w"},
        {linkTitle:"How to properly fit your mask",link:"https://www.youtube.com/watch?v=YPd-XrDhzrQ&t=1s"},
        {linkTitle:"When and how children should wear a mask",link:"https://www.youtube.com/watch?v=UmUxYGKA7as&t=1s"}
      ]
      }

    return (
        <ArticleCoverAndHeader readTime={4} title="Masks And All About Them" Internet previousGuide="/donate-plasma" nextGuide="/first-aid-at-home">
          <div className={styles.introPara}>
            <p>
            Masks should be used as part of a comprehensive strategy of measures to suppress transmission and save lives; the use of a mask alone is not sufficient to provide an adequate level of protection against COVID-19.

            If COVID-19 is spreading in your community, stay safe by taking some simple precautions, such as physical distancing, wearing a mask, keeping rooms well ventilated, avoiding crowds, cleaning your hands, and coughing into a bent elbow or tissue. Check local advice where you live and work. Do it all!
            
            Make wearing a mask a normal part of being around other people. The appropriate use, storage and cleaning or disposal of masks are essential to make them as effective as possible.
            </p>
        </div>

        <h2 className={styles.sliderHeader}>
          How not to wear a mask
        </h2><br/>
        
        <img
        className={`{${styles.articleFirstImage} ${styles.articleImageMobAlert}}`}
        src="https://africacdc.org/wp-content/uploads/2020/05/How-not-to-use-the-face-mask-ENG.jpg"
        alt="first_landscape_img"
      /><br/><br/>
      
      <h2 className={styles.sliderHeader}>
          How to use a mask ?
        </h2>

        <Row row={wearMask}/>
        
        <img
        className={`{${styles.articleFirstImage} ${styles.articleImageMobAlert}}`}
        src="https://pbs.twimg.com/media/EfDA1PeWkAAAeR5?format=jpg&name=large"
        alt="first_landscape_img"
      /><br/><br/>

      <h2 className={styles.sliderHeader}>
          Why masks with valves are banned?
        </h2>

        <div className={styles.introPara}>
            <p>
            These masks may make it easier to breathe out, but as the wearer is doing so, they’re also exhaling their germs into the air around them. Increasingly more medical facilities around the country have banned the use of masks with valves. They do a good job protecting the wearer, but because of the one-way valves, they don’t offer much protection to the people around the wearer. If the wearer is contagious, either knowingly or unknowingly, they could still be spreading the virus to others around them. Since the main reason to wear a mask is to protect others, a simpler mask with a filter may be a better choice.
            </p>
        </div>
        
        <h2 className={styles.sliderHeader}>
          Different masks and their efficiencies
        </h2><br/>
        
        <img
        className={`{${styles.articleFirstImage} ${styles.articleImageMobAlert}}`}
        src="https://i.pinimg.com/originals/77/5f/fe/775ffe68ea992e2d720f064d5e9e4447.jpg"
        alt="first_landscape_img"
      /><br/><br/>

        

      <Row row={refList} links/>
      
        </ArticleCoverAndHeader>
    )
}

export default HelpOnTwitter
